import script from "./CreatedUser.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatedUser.vue?vue&type=script&setup=true&lang=js"

import "./CreatedUser.vue?vue&type=style&index=0&id=1b8c3e36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8c3e36"]])

export default __exports__